<body>
    <div class="container">

        <div class="row" id="signInput">
            <div id="form-signup" class="col-md-7">
                <h2 class=" text-center py-3"> اهلا وسهلا بك مجددا  </h2>
                <p class="text-muted text-center py-2">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى.</p>
        
       
                    <form #authform="ngForm" (ngSubmit)="onSubmit(authform)"  class="col">
                        <div class="form-group bg-white p-4 my-2 " style="width: 80%;">
                         <i class="far fa-envelope float-left" style="font-size: 30px;"></i> <label for="email" class="float-right"> الايميل الشخصي</label>
                           <input 
                             type="text" 
                             class="form-control"
                             id="email"
                             ngModel
                             name="email"
                             required
                             email>
                        </div>
             
                        <div class="form-group bg-white p-4 my-2" style="width: 80%;">
                         <i class="fas fa-unlock"  style="font-size: 30px;"></i> <label for="passowrd" class="float-right"> كلمة المرور</label>
                           <input 
                            type="text" 
                            class="form-control"
                            id="password"
                            ngModel
                            name="passowrd"
                            required
                            password
                            minlength="6">
                        </div>
                        <div class="col-12  text-center py-1">
                     
                            <span >تذكر كلمة المرور </span>
                           <input  type="checkbox" class="" >
                      
                  </div>

                        <button class="btn btn-secondary " type="submit" [disabled]="!authform.valid">تسجيل الدخول</button>           
                       
                            <p class="btn text-right "> <a class="text-dark"  routerLink="/signUp">تسجيل جديد </a> <span><img width="15%" src="https://t3.ftcdn.net/jpg/03/08/40/24/240_F_308402417_GqkJdF2DQE05p84aWzYKbbMn0IKbhQFn.jpg" alt=""></span></p>  
                          
                    </form>


            </div>
            <div id="img-signup" class="col-md-4 mt-5">
                <img width="100%" src="https://images.pexels.com/photos/4050470/pexels-photo-4050470.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" alt="">

            </div>
        </div>

       </div>
     
       
</body>